<template>
  <div>
    <div class="card" style="padding:10px;margin-top:10px">
      <div style="display:flex;justify-content:flex-end;">
        <SearchBar />
        <AdminImportExport />
        <AdminPrintParticipants />
      </div>
      <AdminDropdownFiltreCouleurs style="margin-top:10px;" />
      <b-table
        style="margin-top:15px;"
        default-sort-direction="desc"
        default-sort="created_at"
        :data="filteredList"
        :paginated="this.filteredList.length > 8 ? true : false"
        :per-page="8"
        :pagination-simple="false"
        :striped="true"
        :hoverable="true"
        :checked-rows.sync="printCheckRows"
        checkable
        @check-all="selectAll"
        :is-row-checkable="(row) => row.finish === 1"
      >
        <!-- @check="pushIdParticipantsInArray" 
      --><template>
          <b-table-column
            v-slot="props"
            field="created_at"
            width="40"
            sortable
            numeric
            :label="$t('admin.date')"
            >{{
              props.row.created_at
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/")
            }}</b-table-column
          >

          <b-table-column
            v-slot="props"
            custom-key="admin.prenom"
            width="100"
            field="firstname"
            sortable
            :label="$t('admin.prenom')"
          >
            <b-tooltip
              type="is-danger"
              :active="props.row.firstname.length > 21"
              :label="props.row.firstname"
              >{{ props.row.firstname | truncate(20) }}</b-tooltip
            >
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="admin.nom"
            width="100"
            field="lastname"
            sortable
            :label="$t('admin.nom')"
          >
            <b-tooltip
              type="is-danger"
              :active="props.row.lastname.length > 21"
              :label="props.row.lastname"
              >{{ props.row.lastname | truncate(20) }}</b-tooltip
            >
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="admin.email"
            width="80"
            :label="$t('admin.email')"
            >{{ props.row.email }}</b-table-column
          >

          <b-table-column
            v-slot="props"
            custom-key="admin.profildominant"
            width="20"
            :label="$t('admin.profil.dominant')"
            ><div style="max-height:12px">
              <div v-if="props.row.finish !== 0">
                <div
                  v-for="(color, key) in props.row.profil[0]"
                  :key="key"
                  :class="
                    backgroundColorPastilleDominante(
                      color,
                      key,
                      props.row.profil[0].length
                    )
                  "
                  @click="popUpsignificationCouleurPastilleDom(props, key)"
                >
                  <b-tooltip
                    v-if="props.row.profil[0].length > 0"
                    :label="$t('admin.showSignificationColors')"
                  >
                    <div style="height:20px;width:20px;cursor:pointer" />
                  </b-tooltip>
                </div>
              </div>
              <div v-else style="margin-left:5px;">--</div>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="admin.profilinferieur"
            width="20"
            :label="$t('admin.profil.inferieur')"
          >
            <div style="max-height:12px">
              <div v-if="props.row.finish !== 0">
                <div
                  v-for="(color, key) in props.row.profil[1]"
                  :key="key"
                  :class="
                    backgroundColorPastilleInferieure(
                      color,
                      key,
                      props.row.profil[1].length
                    )
                  "
                  @click="popUpsignificationCouleurPastilleInf(props, key)"
                >
                  <b-tooltip
                    v-if="props.row.profil[1].length > 0"
                    type="is-info"
                    :label="$t('admin.showSignificationColors')"
                  >
                    <div style="height:20px;width:20px;cursor:pointer" />
                  </b-tooltip>
                </div>
              </div>
              <div v-else style="margin-left:5px;">--</div>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="c2"
            style="background-color: rgba(0, 157, 255, 0.07);"
            numeric
            sortable
            field="color2"
            width="40"
            :label="$t('c2')"
            centered
          >
            <span>{{ props.row.color2 !== 0 ? props.row.color2 : "--" }}</span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="c1"
            style="background-color: rgba(255, 93, 0, 0.07);"
            numeric
            sortable
            field="color1"
            width="40"
            :label="$t('c1')"
            centered
          >
            <span>{{ props.row.color1 !== 0 ? props.row.color1 : "--" }}</span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="c4"
            style="background-color: rgba(255, 217, 0, 0.07);"
            numeric
            sortable
            field="color3"
            width="40"
            :label="$t('c4')"
            centered
          >
            <span>{{ props.row.color4 !== 0 ? props.row.color4 : "--" }}</span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="c3"
            style="background-color: rgba(1, 163, 1, 0.07);"
            numeric
            sortable
            field="color4"
            width="40"
            :label="$t('c3')"
            centered
          >
            <span>{{ props.row.color3 !== 0 ? props.row.color3 : "--" }}</span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="admin.lien"
            width="40"
            field
            :label="$t('admin.lien')"
            centered
          >
            <span
              :disabled="props.row.color1 ? false : true"
              @click="openPopupLien(props.row)"
            >
              <img
                class="iconColidee"
                src="~@/assets/img/icons/icon_share.svg"
                alt="trash-icon"
              />
            </span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="cadmin.resultsInd.details"
            centered
            width="40"
            sortable
            :label="$t('admin.resultsInd.details')"
          >
            <span
              :disabled="props.row.color1 ? false : true"
              @click="openPopupDetails(props.row)"
            >
              <img
                class="iconColidee"
                src="~@/assets/img/icons/show-results-icon.png"
                alt="trash-icon"
              />
            </span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            custom-key="common.supprimer"
            centered
            field
            :label="$t('common.supprimer')"
            width="100"
          >
            <span
              v-bind:id="props.row.id"
              @click="delete_participant(props.row.id)"
            >
              <img
                class="iconColidee"
                src="~@/assets/img/icons/icon_trash.svg"
                alt="trash-icon"
              />
            </span>
          </b-table-column>
        </template>
      </b-table>
      <br /><br />

      <AdminFinishedParticipants
        :listFiltered="this.filteredList.length"
        v-if="!this.filteredList.length"
        :type="!this.printCheckRows.length ? 'noRegistered' : 'noColors'"
      />
    </div>

    <!-- Modal pour le lien cliquable-->
    <b-modal :active.sync="isLienModalActive" :width="450">
      <AdminResultsIndividuelsPopupLink :lienParticipants="lienParticipants" />
    </b-modal>
    <!-- modal pour les détails du participants -->
    <b-modal :active.sync="isDetailsModalActive" :width="780">
      <AdminResultsIndividuelsPopupDetails
        :propsParticipant="propsParticipant"
        :seriesButtonsPopUpDetails="seriesButtonsPopUpDetails"
      />
    </b-modal>
    <!-- modal SignificationCouleur -->
    <b-modal :active.sync="isSignificationModalActive" :width="1000">
      <div>
        <significationCouleur :id="id" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import buttons from "../../../data/questions.json";
import significationCouleur from "@/components/popup/SignificationCouleur";
import AdminResultsIndividuelsPopupLink from "@/components/popup/AdminResultsIndividuelsPopupLink";
import AdminResultsIndividuelsPopupDetails from "@/components/popup/AdminResultsIndividuelsPopupDetails";
import AdminDropdownFiltreCouleurs from "@/components/insight/PageDashboard/AdminDropdownFiltreCouleurs";
import AdminFinishedParticipants from "@/components/insight/Utils/AdminFinishedParticipants";
import AdminInfosSearchBarParticipants from "@/components/insight/Utils/AdminInfosSearchBarParticipants";
import AdminImportExport from "@/components/insight/PageDashboard/AdminImportExport";
import AdminPrintParticipants from "@/components/insight/PageDashboard/AdminPrintParticipants";
import SearchBar from "@/components/insight/Utils/SearchBar";
import EventBus from "../../../eventBus";
import { mapGetters } from "vuex";

export default {
  components: {
    significationCouleur,
    AdminResultsIndividuelsPopupLink,
    AdminResultsIndividuelsPopupDetails,
    AdminFinishedParticipants,
    SearchBar,
    AdminInfosSearchBarParticipants,
    AdminDropdownFiltreCouleurs,
    AdminImportExport,
    AdminPrintParticipants,
  },
  props: {
    url_moderateur: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      buttons: buttons,
      isLienModalActive: false,
      isSignificationModalActive: false,
      isDetailsModalActive: false,
      lienParticipants: "",
      propsParticipant: "",
      seriesButtonsPopUpDetails: [],
      id: 1,
      printCheckRows: [],
      arrayEmpty: [],
      windowWidth: window.innerWidth,
      room: "",
    };
  },
  computed: {
    ...mapGetters([
      "insight_resultats_copy",
      "insight_search",
      "insight_en_cours",
      "insight_is_loading_importExport",
      "insight_checkrows_print_participants",
    ]),
    filteredList() {
      this.$store.commit(
        "INSIGHT_CHECKROWS_PRINT_PARTICIPANTS",
        this.printCheckRows.filter((x) => x.finish === 1)
      );
      let listeFiltre = this.insight_resultats_copy;
      return listeFiltre.filter((x) => {
        return (
          x.firstname
            .toLowerCase()
            .includes(this.insight_search.toLowerCase()) ||
          x.lastname
            .toLowerCase()
            .includes(this.insight_search.toLowerCase()) ||
          x.email.toLowerCase().includes(this.insight_search.toLowerCase())
        );
      });
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  filters: {
    truncate(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
  },
  methods: {
    resultatsGroup(url_moderateur) {
      this.$router.push({
        name: "resultats",
        params: { url_moderateur: url_moderateur, type: "resultatGroup" },
      });
    },
    selectAll(rows) {
      if (rows.length > this.printCheckRows.length) {
        this.$nextTick(() => {
          this.printCheckRows = this.filteredList;
        });
      } else {
        this.$nextTick(() => {
          this.printCheckRows = [];
        });
      }
    },
    delete_participant(id) {
      EventBus.$emit("delete_id_participant", id);
    },
    backgroundColorPastilleDominante(profil, key, length) {
      let cssClass = "";

      switch (length) {
        case 1:
          cssClass = `backgroundColor${profil}`;
          break;

        case 2:
          if (key === 0) {
            cssClass = `halfLeft color${profil + 1}`;
          } else {
            cssClass = `halfRight color${profil + 1}`;
          }
          break;

        case 3:
          if (key === 0) {
            cssClass = `thirdLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `thirdCenter color${profil + 1}`;
          } else {
            cssClass = `thirdRight color${profil + 1}`;
          }
          break;

        case 4:
          if (key === 0) {
            cssClass = `quarterTopLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `quarterTopRight color${profil + 1}`;
          } else if (key === 2) {
            cssClass = `quarterBottomLeft color${profil + 1}`;
          } else if (key === 3) {
            cssClass = `quarterBottomRight color${profil + 1}`;
          }
          break;

        default:
          break;
      }
      return cssClass;
    },
    backgroundColorPastilleInferieure(profil, key, length) {
      let cssClass = "";

      switch (length) {
        case 1:
          cssClass = `backgroundColor${profil}`;
          break;

        case 2:
          if (key === 0) {
            cssClass = `halfLeft color${profil + 1}`;
          } else {
            cssClass = `halfRight color${profil + 1}`;
          }
          break;

        case 3:
          if (key === 0) {
            cssClass = `thirdLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `thirdCenter color${profil + 1}`;
          } else {
            cssClass = `thirdRight color${profil + 1}`;
          }
          break;

        case 4:
          if (key === 0) {
            cssClass = `quarterTopLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `quarterTopRight color${profil + 1}`;
          } else if (key === 2) {
            cssClass = `quarterBottomLeft color${profil + 1}`;
          } else if (key === 3) {
            cssClass = `quarterBottomRight color${profil + 1}`;
          }
          break;

        default:
          break;
      }
      return cssClass;
    },
    /* pushIdParticipantsInArray(event) {
      this.arrayEmpty = [];
      for (let i = 0; i < event.length; i++) {
        if (event[i].finish === 1) {
          this.arrayEmpty.push(event[i].id);
        }
      }
      EventBus.$emit("idparticipants", this.arrayEmpty);
    }, */
    popUpsignificationCouleurPastilleDom(props, key = 0) {
      this.id = props.row.profil[0][key];
      this.isSignificationModalActive = true;
    },
    popUpsignificationCouleurPastilleInf(props, key = 0) {
      this.id = props.row.profil[1][key];
      this.isSignificationModalActive = true;
    },
    openPopupDetails(row) {
      this.isDetailsModalActive = true;
      this.seriesButtonsPopUpDetails = [];
      this.propsParticipant = row;
      this.seriesButtonsPopUpDetails.push(
        this.propsParticipant.color1,
        this.propsParticipant.color2,
        this.propsParticipant.color3,
        this.propsParticipant.color4
      );
    },
    openPopupLien(row) {
      this.isLienModalActive = !this.isLienModalActive;
      this.url_resultats = row.url_resultats;
      this.lienParticipants =
        process.env.VUE_APP_URL_INSIGHT + "/c-" + this.url_resultats;
    },
  },
};
</script>
<style scoped>
.iconColidee {
  margin-top: 3px;
  width: 15px;
  height: 18px;
  cursor: pointer;
}
#AdminResultsIndividuelsPopupImportExport {
  z-index: 10;
}
.backgroundColor0 {
  background-color: #ed5b07;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor1 {
  background-color: #448dfe;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor2 {
  background-color: #9edb58;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor3 {
  background-color: #f6da50;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.color1 {
  background-color: #ed5b07;
}
.color2 {
  background-color: #448dfe;
}
.color3 {
  background-color: #9edb58;
}
.color4 {
  background-color: #f6da50;
}

.halfLeft {
  position: relative;
  border-radius: 10px 0px 0px 10px;
  width: 10px;
  height: 20px;
}
.halfRight {
  position: relative;
  border-radius: 0px 10px 10px 0px;
  width: 10px;
  height: 20px;
  top: -20px;
  left: 10px;
}

.thirdLeft {
  position: relative;
  border-radius: 10px 0px 0px 10px;
  width: 7px;
  height: 20px;
  z-index: 5;
}
.thirdCenter {
  position: relative;
  height: 21px;
  width: 20px;
  top: -20px;
  z-index: 1;
  border-radius: 10px;
}
.thirdRight {
  position: relative;
  border-radius: 0px 10px 10px 0px;
  width: 7px;
  height: 20px;
  top: -40px;
  z-index: 5;
  left: 13px;
}

.quarterTopLeft {
  position: relative;
  border-top-left-radius: 10px;
  width: 10px;
  height: 10px;
}
.quarterTopRight {
  position: relative;
  border-top-right-radius: 10px;
  width: 10px;
  height: 10px;
  top: -10px;
  left: 10px;
}
.quarterBottomLeft {
  position: relative;
  border-bottom-left-radius: 10px;
  width: 10px;
  height: 10px;
  top: -10px;
}
.quarterBottomRight {
  position: relative;
  border-bottom-right-radius: 10px;
  width: 10px;
  height: 10px;
  top: -20px;
  left: 10px;
}
.backgroundColor0 {
  background-color: #ed5b07;
  position: relative;
  border-radius: 30px;
}

.backgroundColor1 {
  background-color: #448dfe;
  position: relative;
  border-radius: 20px;
}
.backgroundColor2 {
  background-color: #9edb58;
  position: relative;
  border-radius: 20px;
}
.backgroundColor3 {
  background-color: #f6da50;
  position: relative;
  border-radius: 20px;
}
.halfCirclesLeft0 {
  background-color: #ed5b07;
  width: 16px;
  height: 100%;
  border-radius: 15px 0px 0px 15px;
}

.halfCirclesLeft1 {
  background-color: #448dfe;
  width: 16px;
  height: 100%;
  border-radius: 15px 0px 0px 15px;
}

.halfCirclesLeft2 {
  background-color: #9edb58;
  width: 16px;
  height: 100%;
  border-radius: 15px 0px 0px 15px;
}

.halfCirclesLeft3 {
  background-color: #f6da50;
  width: 16px;
  height: 100%;
  border-radius: 15px 0px 0px 15px;
}

.halfCirclesRight0 {
  background-color: #ed5b07;
  width: 16px;
  height: 100%;
  border-radius: 0px 15px 15px 0px;
}

.halfCirclesRight1 {
  background-color: #448dfe;
  width: 16px;
  height: 100%;
  border-radius: 0px 15px 15px 0px;
}

.halfCirclesRight2 {
  background-color: #9edb58;
  width: 16px;
  height: 100%;
  border-radius: 0px 15px 15px 0px;
}

.halfCirclesRight3 {
  background-color: #f6da50;
  width: 16px;
  height: 100%;
  border-radius: 0px 15px 15px 0px;
}
</style>
